<template>
  <div
    :style="{
      '--bg-color': bgColor ?? '#ecebd2',
    }"
    class="flex flex-col lg:flex-row items-center justify-between space-y-5 lg:space-y-0 px-16 py-6 border-t-2 border-black bg-[--bg-color]"
  >
    <NuxtLink
      :to="useBaseDomainURL('/')"
      class="flex items-center justify-center font-Kontesa text-2xl leading-none font-semibold border-2 border-black shadow-[0_4px] rounded-full px-6 py-5 uppercase bg-beige-low"
    >
      Giving Circles
    </NuxtLink>

    <div
      class="flex flex-col lg:flex-row items-center gap-2 lg:gap-6 relative font-semibold text-xl leading-none uppercase"
    >
      <div class="flex items-center gap-1">
        <span class="font-Kontesa text-[32px] -mb-2">©</span>
        <span class="font-Kontesa">
          Dollar Donation Club {{ new Date().getFullYear() }}
        </span>
      </div>

      <div class="grid grid-cols-2 gap-2 lg:gap-6">
        <NuxtLink
          :to="useBaseDomainURL('/terms')"
          external
          target="_blank"
          class="font-Kontesa underline underline-offset-2 decoration-current decoration-2"
        >
          Terms & conditions
        </NuxtLink>

        <NuxtLink
          to="https://app.termly.io/document/privacy-policy/e5344696-998a-41ba-b8b8-2b2a140d92bd"
          external
          target="_blank"
          class="font-Kontesa underline underline-offset-2 decoration-current decoration-2"
        >
          Privacy Policy
        </NuxtLink>

        <NuxtLink
          to="mailto:hello@givingcircles.io"
          external
          target="_blank"
          class="font-Kontesa underline underline-offset-2 decoration-current decoration-2"
        >
          Support
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  bgColor?: string;
}>();
</script>
